// Drag overlay preview for Inbox triage
import { Box } from '@mui/material';

export default function InboxDragOverlay({ activeTask }) {
  if (!activeTask) return null;

  return (
    <Box
      sx={{
        px: 1.5,
        py: 1,
        bgcolor: 'background.paper',
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
        boxShadow: 3,
        maxWidth: 300,
        fontSize: 14,
      }}
    >
      {activeTask.title}
    </Box>
  );
}
